import {
  showErrorMessage,
  showSuccessMessage,
} from "../components/presentation/common/snackbar";
import jwt_decode from "jwt-decode";

import {
  CoreAPI,
  loginAuth,
  portalBaseUrl,
  resetPasswordAuth,
  storageApi,
  userAPI,
} from "../config";
import { errorMessage, successMessage } from "../utils/responseMessage";
import moment from "moment";
import { customerRelations } from "../utils/constants";

function showPageLoader(dispatch) {
  dispatch({
    type: "SHOW_PAGE_LOADER",
    payload: null,
  });
}

function hidePageLoader(dispatch) {
  dispatch({
    type: "HIDE_PAGE_LOADER",
    payload: null,
  });
}

// LOGIN
export const login = (user, history) => (dispatch) => {
  const setLoading = (payload) => dispatch({ type: "LOGIN_LOADING", payload });
  setLoading(true);
  showPageLoader(dispatch);
  loginAuth
    .post("login", user)
    .then((response) => {
      if (response.data.status) {
        const userId = response.data?.user_data?.invoffuserid;
        const decoded = jwt_decode(response?.data?.token?.access);
        const businessRelationship =
          decoded?.user_data?.customer_relation?.code;
        const isCustomer = customerRelations?.includes(businessRelationship);
        const consentStatus =
          decoded?.user_data?.consents?.consent_status ?? false;
        const redirect = () => {
          history.push({
            pathname: "/my-dashboard",
            state: { fromLogin: true },
          });
        };
        if (consentStatus) {
          if (isCustomer) {
            CoreAPI.get(`customer-portal/dashboard?current_user=${userId}`, {
              headers: {
                "content-type": "application/json",
                Accept: "application/json",
                Authorization: `Token ${response.data?.token?.token}`,
              },
            })
              .then((appResponse) => {
                dispatch({
                  type: "GET_DASHBOARD_LOADING",
                  payload: false,
                });
                dispatch({
                  type: response.data.status ? "LOGIN_SUCCESS" : "LOGIN_FAIL",
                  payload: response.data,
                });
                dispatch({
                  type: "GET_DASHBOARD_DETAILS",
                  payload: appResponse.data,
                });
                const appCount =
                  appResponse?.data?.data?.total_count?.applications ?? 0;
                sessionStorage.setItem("application_count", appCount);
                if (appCount > 0) {
                  redirect();
                  window?.location?.reload();
                } else {
                  history.push("/application/welcome");
                  window?.location?.reload();
                }
                setLoading(false);
              })
              .catch(() => {
                redirect();
                window.location.reload();
              });
          } else {
            dispatch({
              type: response.data.status ? "LOGIN_SUCCESS" : "LOGIN_FAIL",
              payload: response.data,
            });
            redirect();
            setLoading(false);
            window.location.reload();
          }
        } else {
          dispatch({
            type: response.data?.status ? "LOGIN_SUCCESS" : "LOGIN_FAIL",
            payload: response.data,
          });
          setLoading(false);
          dispatch({
            type: "SET_CONSENT_REQ",
            payload: false,
          });
          redirect();
        }
      } else {
        setLoading(false);
        showErrorMessage(response.data.message);
      }
    })
    .catch((err) => {
      setLoading(false);
      showErrorMessage(errorMessage(err));
    });
};

export const getConsentDocument = () => (dispatch) => {
  try {
    const loggedUserData = JSON.parse(sessionStorage.getItem("loggedUserData"));
    const party_business = loggedUserData?.user_data?.party_business?.id;
    storageApi
      .get(
        `static-docs?business_id=${party_business}&category=data_privacy_policy&effective_date=${moment().format(
          "YYYY-MM-DD"
        )}`
      )
      .then((response) => {
        if (response.data) {
          dispatch({
            type: "GET_CONSENT_DOCUMENT",
            payload: response.data,
          });
        }
      });
  } catch (error) {}
};

export const sendConsent = (payload, setOpen) => (dispatch) => {
  try {
    const loggedUserData = JSON.parse(sessionStorage.getItem("loggedUserData"));
    const userid = loggedUserData?.user_data?.id;
    const businessRelationship =
      loggedUserData?.user_data?.customer_relation?.code;
    const isCustomer = customerRelations?.includes(businessRelationship);
    userAPI.post(`user/${userid}/consents`, payload).then((response) => {
      if (response.data) {
        dispatch({
          type: "SEND_CONSENT_REQ",
          payload: response.data.data,
        });
        sessionStorage.setItem("application_count", 0);
        setOpen?.(false);
        sessionStorage.setItem("consent", true);
        dispatch({
          type: "SET_CONSENT_REQ",
          payload: true,
        });
        if (isCustomer) {
          window.location.href = "/application/welcome";
        } else {
          window.location.href = "/my-dashboard";
        }
      }
    });
  } catch (error) {
    showErrorMessage(errorMessage(error));
  }
};

export const registerUser = (user, history) => (dispatch) => {
  showPageLoader(dispatch);

  loginAuth
    .post("register-user", user)
    .then((response) => {
      if (response.data.status) {
        showSuccessMessage(response.data?.message);
        setTimeout(function () {
          history.push("/login");
        }, 1000);
      } else {
        showErrorMessage(response.data.message);
      }
    })
    .catch(function (error) {
      showErrorMessage(error?.data?.message);
    })
    .finally(function () {
      hidePageLoader(dispatch);
    });
};

export const forgotPassword =
  ({ payload, setRemainingTime, history }) =>
  (dispatch) => {
    dispatch({
      type: "FORGOT_PASSWORD_LOADING",
      payload: true,
    });
    loginAuth
      .post("forgot_password", payload)
      .then((response) => {
        if (response?.data?.status) {
          showSuccessMessage(response.data?.message);
          history?.push({
            pathname: "/email-check",
            state: payload,
          });
          setRemainingTime?.(300);
          dispatch({
            type: "FORGOT_PASSWORD_LOADING",
            payload: false,
          });
        } else {
          showErrorMessage(response.data?.message);
          dispatch({
            type: "FORGOT_PASSWORD_LOADING",
            payload: false,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "FORGOT_PASSWORD_LOADING",
          payload: false,
        });
        showErrorMessage(error.data?.message);
      });
  };

export const updatePassword = (data, history) => (dispatch) => {
  showPageLoader(dispatch);
  const token = sessionStorage.getItem("token");
  if (token !== null) {
    loginAuth.defaults.headers.common["Authorization"] = "Token " + token;
  }
  loginAuth
    .post("change_password", data)
    .then((response) => {
      hidePageLoader(dispatch);

      if (response.data.status) {
        dispatch({
          type: "UPDATE_PASSWORD_SUCCESS",
          payload: response.data,
        });
        history.push("/login");

        showSuccessMessage(response.data?.message);
      } else {
        showErrorMessage(response.data?.message);
      }
    })
    .catch(function (error) {
      showErrorMessage(error?.data?.message);
    })
    .finally(function () {
      hidePageLoader(dispatch);
    });
};

export const setNewPassword = (data) => (dispatch) => {
  showPageLoader(dispatch);
  loginAuth
    .post("set_password", data)
    .then((response) => {
      hidePageLoader(dispatch);
      if (response.data.status) {
        dispatch({
          type: "UPDATE_PASSWORD_SUCCESS",
          payload: response.data,
        });
        showSuccessMessage(response.data?.message);
        setTimeout(function () {
          window.location.href = "/login";
        }, 1000);
      } else {
        showErrorMessage(response.data.message);
      }
    })
    .catch(function (error) {
      showErrorMessage(error.data.message);
    })
    .finally(function () {
      hidePageLoader(dispatch);
    });
};

export const changePasswordInner =
  ({ formData, currentUser }) =>
  (dispatch) => {
    dispatch({
      type: "CHANGE_PASSWORD_LOADING",
      payload: true,
    });
    resetPasswordAuth
      .post(`change_password/login?current_user=${currentUser}`, formData)
      .then((response) => {
        if (response.data.status) {
          showSuccessMessage(response.data?.message);
          sessionStorage.clear();
          window.location.reload();
          dispatch({
            type: "CHANGE_PASSWORD_LOADING",
            payload: false,
          });
        } else {
          showErrorMessage(errorMessage(response));
          dispatch({
            type: "CHANGE_PASSWORD_LOADING",
            payload: false,
          });
        }
      })
      .catch(function (error) {
        showErrorMessage(errorMessage(error));
        dispatch({
          type: "CHANGE_PASSWORD_LOADING",
          payload: false,
        });
      });
  };

export const sendChangePasswordOtp =
  ({ payload, setOptField, setShowTwoFaModal }) =>
  (dispatch) => {
    dispatch({
      type: "SEND_OTP_LOADING",
      payload: true,
    });
    resetPasswordAuth
      .post(`/send-otp`, payload)
      .then((response) => {
        dispatch({
          type: "SEND_OTP_DATA_SUC",
          payload: response.data,
        });
        dispatch({
          type: "SEND_OTP_LOADING",
          payload: false,
        });
        showSuccessMessage(successMessage(response));
        setOptField?.(true);
        setShowTwoFaModal?.(false);
      })
      .catch(function (error) {
        dispatch({
          type: "SEND_OTP_LOADING",
          payload: false,
        });
        showErrorMessage(errorMessage(error));
      });
  };

export const changePasswordOuter = (data, history) => (dispatch) => {
  showPageLoader(dispatch);
  loginAuth
    .post("change_password", data)
    .then((response) => {
      hidePageLoader(dispatch);
      if (response.data.status) {
        showSuccessMessage(response.data?.message);

        history.push("/login");
      } else {
        showErrorMessage(response.data?.message);
      }
    })
    .catch(function (error) {
      showErrorMessage(error?.data?.message);
    })
    .finally(function () {
      hidePageLoader(dispatch);
    });
};

export const getUserListQuestions = (res) => (dispatch) => {
  showPageLoader(dispatch);
  loginAuth
    .get("question_for_user", res)
    .then((response) => {
      hidePageLoader(dispatch);
      if (response.data.status === true) {
        dispatch({
          type: "QUESTION_LIST",
          payload: response.data,
        });
      } else {
        //
      }
    })
    .catch(function (error) {
      //
    })
    .finally(function () {
      hidePageLoader(dispatch);
    });
};

export const getRegisteredContactDetails = (contact_id) => (dispatch) => {
  showPageLoader(dispatch);
  loginAuth
    .get("party/person/detail/" + contact_id)
    .then((response) => {
      if (response.data.status === true) {
        dispatch({
          type: "REGISTERED_USER_DATA",
          payload: response.data,
        });
      } else {
        //
      }
    })
    .catch(function (error) {
      //
    })
    .finally(function () {
      //
    });
};

export const verifyActivationKey =
  ({ payload, source }) =>
  (dispatch) => {
    loginAuth
      .post(`verify-activation-key`, payload)
      .then(() => {})
      .catch((err) => showErrorMessage(errorMessage(err)));
  };

export const getHealthCheck = () => (dispatch) => {
  portalBaseUrl
    .get("health/")
    .then(() => {
      dispatch({
        type: "IS_SERVICE_UNAVAILABLE",
        payload: false,
      });
    })
    .catch((err) => {
      if (err.code === "ERR_NETWORK" || err.message === "Network Error") {
        dispatch({
          type: "IS_SERVICE_UNAVAILABLE",
          payload: true,
        });
      }
    });
};

export const setConsent = (payload) => (dispatch) => {
  dispatch({
    type: "SET_CONSENT_REQ",
    payload: payload,
  });
};
